import { ArrowRightIcon, CheckIcon, RepeatClockIcon } from "@chakra-ui/icons";
import { Center } from "@chakra-ui/react";

const iconMap = {
  read: CheckIcon,
  readLater: RepeatClockIcon,
  skipped: ArrowRightIcon,
};

const colorMapChecked = {
  read: "#27ae60",
  readLater: "#0095FF",
  skipped: "#FFAA00",
};

const RoundCheckbox = ({ iconName, isChecked, onChange, title, readOnly }) => {
  const IconComponent = iconMap[iconName];
  const checkBoxProps = {
    color: readOnly
      ? isChecked
        ? colorMapChecked[iconName]
        : "#58627A"
      : isChecked
      ? "#FFFFFF"
      : "#222B45",
    boxSize: iconName === "skipped" ? "0.7em" : "0.75em",
  };

  return (
    <Center
      borderRadius={readOnly ? "0" : "full"}
      w={readOnly ? "20px" : "24px"}
      h="24px"
      alignItems="center"
      cursor={readOnly ? "default" : "pointer"}
      bg={
        readOnly
          ? "transparent"
          : isChecked
          ? colorMapChecked[iconName]
          : "gray.900"
      }
      onClick={readOnly ? undefined : onChange}
      title={title}
    >
      {(!readOnly || isChecked || iconName !== "read") && (
        <IconComponent {...checkBoxProps} />
      )}
    </Center>
  );
};

export default RoundCheckbox;
